import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
import rootReducer, { history } from 'store/modules'
import { errorMiddleware } from 'store/middlewares/errorMiddleware'
import { confirmMiddleware } from 'store/middlewares/confirmMiddleware'
import { loadUser } from 'redux-oidc'
import { userManager } from 'auth/userManager'
export { history }

const initialState = {}
const enhancers = []
const middleware = [thunk, confirmMiddleware, promise, errorMiddleware]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

const isUserLoggedIn = (user) => Boolean(user && user.access_token && !user.expired)
loadUser(store, userManager)
  .then(user => {
    if (!isUserLoggedIn(user)) {
      userManager.signinSilent()
        .catch(err => {
          console.log('silent signin failed: %o', err)
          userManager.signinRedirect()
        })
    }
  })


export default store
